module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"notifications":{"notifications":"お知らせ","productUpdate":"製品の更新","news":"ニュース","all":"すべて","read":"読んだ","unread":"未読","seeMore":"もっと見る","gotIt":"了解"}},"en":{"notifications":{"notifications":"Notifications","productUpdate":"Product Update","news":"News","all":"All","read":"Read","unread":"Unread","seeMore":"See more","gotIt":"Got it"}}}')
  delete Component.options._Ctor
}
